import ReactGA from 'react-ga4';

// Google Analytics Tracking ID (Gerçek ID ile değiştir)
const TRACKING_ID = 'G-XXXXXXXXXX'; // TODO: Gerçek tracking ID ile değiştir

export const initGA = () => {
  if (TRACKING_ID === 'G-XXXXXXXXXX') {
    console.warn('[Analytics] Google Analytics Tracking ID henüz ayarlanmadı');
    return;
  }
  
  ReactGA.initialize(TRACKING_ID, {
    gaOptions: {
      siteSpeedSampleRate: 100
    }
  });
  console.log('[Analytics] Google Analytics initialized');
};

export const trackPageView = (path: string) => {
  if (TRACKING_ID === 'G-XXXXXXXXXX') return;
  
  ReactGA.send({ hitType: 'pageview', page: path });
  console.log('[Analytics] Page view:', path);
};

export const trackEvent = (
  category: string, 
  action: string, 
  label?: string, 
  value?: number
) => {
  if (TRACKING_ID === 'G-XXXXXXXXXX') return;
  
  ReactGA.event({
    category,
    action,
    label,
    value
  });
  console.log('[Analytics] Event:', { category, action, label, value });
};

// E-commerce tracking
export const trackProductView = (productId: string, productName: string, price: number) => {
  trackEvent('Product', 'View', productName, price);
};

export const trackAddToCart = (productId: string, productName: string, price: number, quantity: number) => {
  trackEvent('Cart', 'Add', productName, price * quantity);
};

export const trackRemoveFromCart = (productId: string, productName: string) => {
  trackEvent('Cart', 'Remove', productName);
};

export const trackCheckoutStep = (step: number, option?: string) => {
  trackEvent('Checkout', `Step ${step}`, option);
};

export const trackPurchase = (orderId: string, total: number, items: number) => {
  if (TRACKING_ID === 'G-XXXXXXXXXX') return;
  
  ReactGA.event({
    category: 'Ecommerce',
    action: 'Purchase',
    label: orderId,
    value: total
  });
  console.log('[Analytics] Purchase:', { orderId, total, items });
};

// User interactions
export const trackButtonClick = (buttonName: string, location: string) => {
  trackEvent('Button', 'Click', `${buttonName} - ${location}`);
};

export const trackFormSubmit = (formName: string, success: boolean) => {
  trackEvent('Form', success ? 'Submit Success' : 'Submit Error', formName);
};

export const trackSearch = (searchTerm: string, resultsCount: number) => {
  trackEvent('Search', 'Query', searchTerm, resultsCount);
};
